import { unlocalizeRouteName } from '@marketplace/helpers/router.js'
import Vue from 'vue'

const mixin = {
    computed: {
        $page() {
            return {
                currentRouteName: unlocalizeRouteName(this.$route.name),
                isHomePage: unlocalizeRouteName(this.$route.name) === 'home',
                isMarketplacePage:
                    unlocalizeRouteName(this.$route.name) === 'marketplace',
                isListingsPage:
                    unlocalizeRouteName(this.$route.name) === 'productsearch',
                isSearchPage:
                    unlocalizeRouteName(this.$route.name) === 'search',
                isSearchablePage:
                    unlocalizeRouteName(this.$route.name) === 'productsearch' ||
                    unlocalizeRouteName(this.$route.name) === 'search',
                isProductPage:
                    unlocalizeRouteName(this.$route.name) === 'product',
                isStorefrontPage:
                    unlocalizeRouteName(this.$route.name) === 'storefront',
                isStorefrontRelatablePage:
                    unlocalizeRouteName(this.$route.name)?.includes(
                        'storefront'
                    ) ||
                    unlocalizeRouteName(this.$route.name)?.includes('store'),
                isCollectionPage:
                    unlocalizeRouteName(this.$route.name) ===
                    'storefront-collection',
                isCartPage: unlocalizeRouteName(this.$route.name) === 'cart',
                isOrderPage: unlocalizeRouteName(this.$route.name) === 'order',
                isNewListingsPage:
                    unlocalizeRouteName(this.$route.name) === 'listings',
                isWallPage: unlocalizeRouteName(this.$route.name) === 'wall',
                isDropshippingPage: unlocalizeRouteName(
                    this.$route.name
                )?.startsWith('ds'),
                isTrademartPage: unlocalizeRouteName(
                    this.$route.name
                )?.startsWith('trademart'),
                isSignupPage: unlocalizeRouteName(this.$route.name)?.includes(
                    '-signup'
                ),
                isDsSignupPage: unlocalizeRouteName(this.$route.name)?.includes(
                    '-signup-dropshipping'
                ),
            }
        },
    },
}

Vue.mixin(mixin)
